import {EventType, EventKind, buildEventCreator, overrideKeys} from 'services/analytics';

export const converter = overrideKeys<StartBudgetEventPayload>({
  days: 'period_exact',
  weeks: 'period_weeks',
  amount: 'budget',
});

export const name = EventKind.CreateBudget;
export const createEvent = buildEventCreator<EventType.Detailed, StartBudgetEventPayload>({
  name,
  converter,
});
